import { QRCodeSVG } from 'qrcode.react';
import { publicReportUrl } from '@/lib/appSurface';

// Story 089 — QR on TV/projector pages, linking to the respective public
// page so spectators can scan the wall display and open the live report.
// `data-qr-value` mirrors the encoded URL for acceptance tests.

interface Props {
  slug: string;
  reportPath: string;
}

export function TvQrCode({ slug, reportPath }: Props) {
  const url = publicReportUrl(slug, reportPath);
  return (
    <div
      data-testid="tv-qr-code"
      data-qr-value={url}
      className="fixed bottom-4 right-4 rounded border bg-white p-2 shadow"
    >
      <QRCodeSVG value={url} size={96} />
    </div>
  );
}
